module.exports = __webpack_public_path__ + "img/Bush-regen-300px.659a392f.jpg";